// extracted by mini-css-extract-plugin
export var borderRadius = "_53-4";
export var large = "_53-3";
export var logoContainer = "_53-0";
export var nameLogo = "_53-2";
export var small = "_53-1";